export class ApiError extends Error {
  responseText: string
  url: string
  status: number

  constructor(response: Response, responseText: string) {
    super(
      `API response not ok trying to call ${response.url}: ${response.status} ${response.statusText}`
    )
    this.name = 'ApiError'
    this.responseText = responseText
    this.status = response.status
    this.url = response.url
  }

  isClientError() {
    return !this.isServerError()
  }

  isServerError() {
    return this.status >= 500
  }
}
